const glider = {
  primary: {
    main: '#3646f5',
    50: '#e1e3fe',
    100: '#c3c8fc',
    150: '#afb5fb',
    200: '#9ba3fa',
    300: '#7c87f9',
    400: '#5e6bf7',
    500: '#3646f5',
    600: '#2e3cd0',
    700: '#2631ac',
    750: '#202a93',
    800: '#1b237b',
    850: '#161c62',
    900: '#10154a',
  },
  secondary: {
    main: '#1a1f4a',
    50: '#000', // sidebar lang switch text
    100: '#babcc9',
    150: '#a3a5b7',
    200: '#8d8fa5',
    300: '#000', // sidebar text
    400: '#484c6e',
    500: '#8ACDFF', // sidebar lang switch background: hover
    600: '#8ACDFF', // sidebar lang switch background
    700: '#121634',
    750: '#10132c',
    800: '#8ACDFF', // sidebar background
    850: '#0a0c1e',
    900: '#080916',
  },
};

export default glider;
